import VueRouter, { RouteConfig } from 'vue-router'

const List = () => import('../views/winter-2023/List.vue')

const Preview = () => import('../views/winter-2023/Preview.vue')

const Poster = () => import('../views/winter-2023/Poster.vue')

const Stat = () => import('../views/winter-2023/Stat.vue')

const CreateStep1 = () => import('../views/winter-2023/CreateStep1.vue')

const CreateStep2 = () => import('../views/winter-2023/CreateStep2.vue')

const DetailOfSafeLessons = () => import('../views/winter-2023/DetailOfSafeLessons.vue')

const DetailOfPELessons = () => import('../views/winter-2023/DetailOfPELessons.vue')

const DetailOfQAOrSkills = () => import('../views/winter-2023/DetailOfQAOrSkills.vue')

const ActivePage = () => import('../views/winter-2023/ActivePage.vue')

const DeliveryAddressEdit = () => import('../views/winter-2023/DeliveryAddressEdit.vue')

const SpecialTrainingList = () => import('../views/winter-2023/SpecialTrainingList.vue')

const SpecialTrainingAssign = () => import('../views/winter-2023/SpecialTrainingAssign.vue')

const PlanDetail = () => import('../views/winter-2023/PlanDetail.vue')

const StudentTrainingDetail = () => import('../views/winter-2023/StudentTrainingDetail.vue')

const StudentTrainingRecordDetail = () => import('../views/winter-2023/StudentTrainingRecordDetail.vue')

const QuestionBank = () => import('../views/winter-2023/QuestionBank.vue')

const QuestionDetail = () => import('../views/winter-2023/QuestionDetail.vue')

const PhysicalHealthKnowledgeList = () => import('../views/winter-2023/PhysicalHealthKnowledgeList.vue')

const PhysicalHealthKnowledge = () => import('../views/winter-2023/PhysicalHealthKnowledge.vue')

const QuestionExamAssign = () => import('../views/winter-2023/QuestionExamAssign.vue')

const QuestionPracticeAssign = () => import('../views/winter-2023/QuestionPracticeAssign.vue')

const QuestionClazzResultDetail = () => import('../views/winter-2023/QuestionClazzResultDetail.vue')

const ExamClazzResultDetail = () => import('../views/winter-2023/ExamClazzResultDetail.vue')

const ExamStudentResultDetail = () => import('../views/winter-2023/ExamStudentResultDetail.vue')

const ExamDetail = () => import('../views/winter-2023/ExamDetail.vue')

const ExamResultForStudent = () => import('../views/winter-2023/ExamResultForStudent.vue')

const ExamStudentNotify = () => import('../views/winter-2023/ExamStudentNotifyPage.vue')

const MixSubjectsList = () => import('../views/winter-2023/MixSubjectsList.vue')

const MixSubjectsClazzDetail = () => import('../views/winter-2023/MixSubjectsClazzDetail.vue')

const MixSubjectsStudentDetail = () => import('../views/winter-2023/MixSubjectsStudentDetail.vue')

export const listRoute: RouteConfig = {
  path: '/winter-2023-list',
  name: 'winter_2023_list',
  component: List,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '作业列表',
  },
}

export const statRoute: RouteConfig = {
  path: '/winter-2023-stat',
  name: 'winter_2023_stat',
  component: Stat,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '寒假作业',
  },
}

export const previewRoute: RouteConfig = {
  path: '/winter-2023-preview',
  name: 'winter_2023_preview',
  component: Preview,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '作业详情',
  },
}

export const posterRoute: RouteConfig = {
  path: '/winter-2023-poster',
  name: 'winter_2023_poster',
  component: Poster,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '分享海报',
  },
}

export const createStep1Route: RouteConfig = {
  path: '/winter-2023-create-step1',
  name: 'winter_2023_create-step1',
  component: CreateStep1,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '布置寒假作业',
  },
}

export const createStep2Route: RouteConfig = {
  path: '/winter-2023-create-step2',
  name: 'winter_2023_create-step2',
  component: CreateStep2,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '布置寒假作业',
  },
}

export const detailOfSafeLessonsRoute: RouteConfig = {
  path: '/winter-2023-detail-safelesson',
  name: 'winter_2023_detail_safelesson',
  component: DetailOfSafeLessons,
  props: (route) => ({
    ...route.query,
    ...route.params,
    gradeNos: JSON.parse(route.query.gradeNos as string),
    startTime: JSON.parse(route.query.startTime as string),
    endTime: JSON.parse(route.query.endTime as string),
  }),
  meta: {
    title: '在线课详情',
  },
}

export const detailOfPELessonsRoute: RouteConfig = {
  path: '/winter-2023-detail-PElesson',
  name: 'winter_2023_detail_PElesson',
  component: DetailOfPELessons,
  props: (route) => ({
    ...route.query,
    ...route.params,
    gradeNos: JSON.parse(route.query.gradeNos as string),
    startTime: JSON.parse(route.query.startTime as string),
    endTime: JSON.parse(route.query.endTime as string),
  }),
  meta: {
    title: '体育作业详情',
  },
}

export const detailOfQAOrSkillsRoute: RouteConfig = {
  path: '/winter-2023-detail-QA-or-skills',
  name: 'winter_2023_detail_QA_or_skills',
  component: DetailOfQAOrSkills,
  props: (route) => ({
    ...route.query,
    ...route.params,
    gradeNos: JSON.parse(route.query.gradeNos as string),
  }),
}

export const activePageRoute: RouteConfig = {
  path: '/winter-2023-active-page',
  name: 'winter_2023_active_page',
  component: ActivePage,
  props: (route) => ({ ...route.query, ...route.params, qd: route.query.qd }),
  meta: {
    title: '寒假体育作业',
  },
}

export const deliveryAddressEditRoute: RouteConfig = {
  path: '/winter-2023-delivery-address-edit',
  name: 'winter_2023_delivery_address_edit',
  component: DeliveryAddressEdit,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '填写收货地址',
  },
}

export const specialTrainingListRoute: RouteConfig = {
  path: '/winter-2023-special-training-list',
  name: 'winter_2023_special_training_list',
  component: SpecialTrainingList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '专项训练',
  },
}

export const specialTrainingAssignRoute: RouteConfig = {
  path: '/winter-2023-special-assign',
  name: 'winter_2023_special_assign',
  component: SpecialTrainingAssign,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '布置训练任务',
  },
}

export const planDetailRoute: RouteConfig = {
  path: '/winter-2023-plan-detail',
  name: 'winter_2023_plan_detail',
  component: PlanDetail,
  props: (route) => ({ ...route.query, ...route.params, id: route.query.id }),
  meta: {
    title: '训练计划',
  },
}

export const physicalHealthKnowledgeListRoute: RouteConfig = {
  path: '/winter-2023-physical-health-knowledge-list',
  name: 'winter_2023_physical_health_knowledge_list',
  component: PhysicalHealthKnowledgeList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '体育健康知识',
  },
}

export const examClazzResultDetailRoute: RouteConfig = {
  path: '/winter-2023-exam-clazz-result-detail',
  name: 'winter_2023_exam_clazz_result_detail',
  component: ExamClazzResultDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '测试统计',
  },
}

export const examStudentResultDetailRoute: RouteConfig = {
  path: '/winter-2023-exam-student-result-detail',
  name: 'winter_2023_exam_student_result_detail',
  component: ExamStudentResultDetail,
  props: (route) => ({
    ...route.query,
    ...route.params,
    classId: +route.query.classId,
    clazzOption: JSON.parse(route.query.clazzOption as string),
  }),
  meta: {
    title: '测试统计',
  },
}

export const physicalHealthKnowledgeRoute: RouteConfig = {
  path: '/winter-2023-physical-health-knowledge',
  name: 'winter_2023_physical_health_knowledge',
  component: PhysicalHealthKnowledge,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '训练计划',
  },
}

export const questionBankRoute: RouteConfig = {
  path: '/winter-2023-physical-question-bank',
  name: 'winter_2023_physical_question_bank',
  component: QuestionBank,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '知识库',
  },
}

export const questionDetailRoute: RouteConfig = {
  path: '/winter-2023-physical-question-detail',
  name: 'winter_2023_physical_question_detail',
  component: QuestionDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '题目详情',
  },
}

export const questionExamAssignRoute: RouteConfig = {
  path: '/winter-2023-physical-question-exam-assign',
  name: 'winter_2023_physical_question_exam_assign',
  component: QuestionExamAssign,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '布置考试',
  },
}

export const questionClazzResultDetailRoute: RouteConfig = {
  path: '/winter-2023-question-clazz-result-detail',
  name: 'winter_2023_question_clazz_result_detail',
  component: QuestionClazzResultDetail,
  props: (route) => ({ ...route.query, ...route.params, training: JSON.parse(route.query.training as string) }),
  meta: {
    title: '训练表现',
  },
}

export const questionStudentResultDetailRoute: RouteConfig = {
  path: '/winter-2023-question-student-result-detail',
  name: 'winter_2023_question_student_result_detail',
  component: StudentTrainingDetail,
  props: (route) => ({
    ...route.query,
    ...route.params,
    training: JSON.parse(route.query.training as string),
    clazzOptions: JSON.parse(route.query.clazzOptions as string),
    challengeClassId: route.query.challengeClassId,
  }),
  meta: {
    title: '训练表现',
  },
}

export const examDetailRoute: RouteConfig = {
  path: '/winter-2023-exam-detail',
  name: 'winter_2023_exam_detail',
  component: ExamDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '试卷详情',
  },
}

export const examResultForStudentRoute: RouteConfig = {
  path: '/winter-2023-exam-result-for-student',
  name: 'winter_2023_exam_result_for_student',
  component: ExamResultForStudent,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '学生答题详情',
  },
}

export const questionStudentTrainingRecordDetailRoute: RouteConfig = {
  path: '/winter_2023_question_student_training_record_detail',
  name: 'winter_2023_question_student_training_record_detail',
  component: StudentTrainingRecordDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '个人训练记录',
  },
}

export const questionPracticeAssignRoute: RouteConfig = {
  path: '/winter-2023-physical-question-practice-assign',
  name: 'winter_2023_physical_question_practice_assign',
  component: QuestionPracticeAssign,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '布置练习',
  },
}

export const examStudentNotifyPageRoute: RouteConfig = {
  path: '/winter-2023-exam-notify',
  name: 'winter_2023_exam_notify',
  component: ExamStudentNotify,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '线上考试通知',
  },
}

export const mixSubjectsListRoute: RouteConfig = {
  path: '/winter-2023-mix-subjects-list',
  name: 'winter_2023_mix_subjects_list',
  component: MixSubjectsList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '跨学科实践',
  },
}

export const mixSubjectsClazzDeatailRoute: RouteConfig = {
  path: '/winter-2023-mix-subjects-clazz-detail',
  name: 'winter_2023_mix_subjects_clazz_detail',
  component: MixSubjectsClazzDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '班级统计',
  },
}

export const mixSubjectsStudentDeatailRoute: RouteConfig = {
  path: '/winter-2023-mix-subjects-student-detail',
  name: 'winter_2023_mix_subjects_student_detail',
  component: MixSubjectsStudentDetail,
  props: (route) => ({ ...route.query, ...route.params, class_id: Number(route.query.class_id) }),
  meta: {
    title: '班级统计',
  },
}

export default [
  listRoute,
  previewRoute,
  posterRoute,
  statRoute,
  createStep1Route,
  createStep2Route,
  detailOfSafeLessonsRoute,
  detailOfPELessonsRoute,
  detailOfQAOrSkillsRoute,
  activePageRoute,
  deliveryAddressEditRoute,
  specialTrainingListRoute,
  specialTrainingAssignRoute,
  planDetailRoute,
  physicalHealthKnowledgeRoute,
  questionBankRoute,
  questionDetailRoute,
  questionExamAssignRoute,
  questionPracticeAssignRoute,
  questionClazzResultDetailRoute,
  questionStudentResultDetailRoute,
  questionStudentTrainingRecordDetailRoute,
  physicalHealthKnowledgeListRoute,
  examClazzResultDetailRoute,
  examStudentResultDetailRoute,
  examDetailRoute,
  examResultForStudentRoute,
  examStudentNotifyPageRoute,
  mixSubjectsListRoute,
  mixSubjectsClazzDeatailRoute,
  mixSubjectsStudentDeatailRoute,
]

export function redirectToSummerVacation2022DeliveryAddressEdit(router: VueRouter) {
  router.replace({ name: deliveryAddressEditRoute.name })
}

export function navToSpecialTrainingPlanDetail(router: VueRouter, id: string, imgUrl: string, from?: string) {
  router.push({ name: planDetailRoute.name, query: { id, imgUrl, from } })
}

export function navToSpecialTrainingAssign(router: VueRouter) {
  router.push({ name: specialTrainingAssignRoute.name })
}

export function navToQuestionBank(router: VueRouter) {
  router.push({ name: questionBankRoute.name })
}

export function navToQuestionDetail(router: VueRouter, id: string) {
  router.push({ name: questionDetailRoute.name, query: { id } })
}

export function navToQuestionExamAssign(router: VueRouter, id: string, name: string, totalQuestions: string) {
  router.push({
    name: questionExamAssignRoute.name,
    query: {
      id,
      name,
      totalQuestions,
    },
  })
}

export function navToQuestionPracticeAssign(router: VueRouter, id: string, name: string) {
  router.push({
    name: questionPracticeAssignRoute.name,
    query: {
      id,
      name,
    },
  })
}

export function navToStudentTrainingResultDetail(router: VueRouter) {
  router.push({ name: questionStudentResultDetailRoute.name })
}

export function navToStudentTrainingRecordDetail(router: VueRouter) {
  router.push({ name: questionStudentTrainingRecordDetailRoute.name })
}
